import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function RejectDialog({ player, open, onOpenChange, onDone }) {
  const [reason, setReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (!reason.trim()) {
      toast.error("Skriv en begrunnelse");
      return;
    }
    try {
      setSubmitting(true);
      await api.post(`/players/${player.id}/status`, { status: "rejected", reason });
      toast.success("Spiller avvist – melding sendt");
      onOpenChange(false);
      setReason("");
      onDone && onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Kunne ikke avvise");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase tracking-tight text-2xl">Avvis spiller</DialogTitle>
        </DialogHeader>
        <div className="text-sm text-neutral-600">{player?.full_name} (#{player?.jersey_number})</div>
        <div>
          <Label className="text-xs uppercase tracking-widest">Begrunnelse</Label>
          <Textarea
            data-testid="reject-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="F.eks. spilleren har spilt 4. divisjon eller høyere / deltar i annen serie."
            className="rounded-sm min-h-[120px]"
          />
          <p className="text-xs text-neutral-500 mt-2">Begrunnelse lagres som melding tilknyttet spilleren.</p>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="rounded-sm">Avbryt</Button>
          <Button data-testid="confirm-reject" disabled={submitting} onClick={submit} className="bg-rose-600 hover:bg-rose-700 text-white rounded-sm font-heading uppercase tracking-widest">
            {submitting ? "Lagrer…" : "Avvis spiller"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
